import { apiGet } from './client.js';
import type { PaginatedMeta } from './tickets.js';

export type AuditLogEntry = {
  id: string;
  tenantId: string;
  storeId?: string | null;
  userId?: string | null;
  userName?: string | null;
  pinVerified: boolean;
  action: string;
  entityType?: string | null;
  entityId?: string | null;
  entityLabel?: string | null;
  beforeValue?: Record<string, unknown> | null;
  afterValue?: Record<string, unknown> | null;
  metadata?: Record<string, unknown>;
  ipAddress?: string | null;
  userAgent?: string | null;
  createdAt: string;
};

export type AuditLogListParams = {
  userId?: string;
  action?: string;
  entityType?: string;
  entityId?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  pageSize?: number;
};

export function listAuditLog(params?: AuditLogListParams) {
  return apiGet<AuditLogEntry[], PaginatedMeta>('/api/v1/audit-log', { params });
}

export function getEntityAuditLog(entityType: string, entityId: string) {
  return apiGet<AuditLogEntry[]>(`/api/v1/audit-log/entity/${encodeURIComponent(entityType)}/${entityId}`).then(
    (r) => r.data,
  );
}
